import { createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import { getAuthTokenCookie } from 'constants/auth';

function getAuthStateFromCookie() {
  const token = getAuthTokenCookie();
  if (!token) {
    return { isAuthenticated: false, username: null, roles: [] };
  }
  try {
    const decoded = jwtDecode(token);
    const username = decoded.conta || null;
    const roles = decoded.roles || [];
    return { isAuthenticated: true, username, roles };
  } catch {
    return { isAuthenticated: false, username: null, roles: [] };
  }
}

const initialState = getAuthStateFromCookie();

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
});

export const selectUsername = (state) => state.auth.username;

export default authSlice.reducer;
